import { render, staticRenderFns } from "./pagings.vue?vue&type=template&id=1203d07f&scoped=true&"
import script from "./pagings.vue?vue&type=script&lang=js&"
export * from "./pagings.vue?vue&type=script&lang=js&"
import style0 from "./pagings.vue?vue&type=style&index=0&id=1203d07f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203d07f",
  null
  
)

export default component.exports